import { TArticle, TComment, TUser } from '../models/common';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

class HelperService {
  formatTime(minutes: number) {
    if (minutes < 60) {
      return minutes + ' ' + (minutes === 1 ? 'minute' : 'minutes');
    } else if (minutes < 1440) {
      const hours = Math.floor(minutes / 60);
      return hours + ' ' + (hours === 1 ? 'hour' : 'hours');
    } else {
      const days = Math.floor(minutes / 1440);
      return days + ' ' + (days === 1 ? 'day' : 'days');
    }
  }

  repliedornot(person: TUser, commentCount: number, time: any) {
    let action = 'replied';
    if (commentCount == null || commentCount === 0) {
      action = 'posted';
    }
    return `${person.username} ${action} ${time} ago`;
  }

  capitalizeFirstLowercaseRest = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  getFileExtension(fileName: string) {
    const fileParts = fileName.split('.');
    if (fileParts.length > 1) {
      return `.${fileParts[fileParts.length - 1]}`;
    }
    return '';
  }

  formatDateToMonthDayYear(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };

    return date.toLocaleDateString(undefined, options);
  }

  getNavigateLink(value: TUser | TArticle) {
    if ('username' in value) {
      return '/u/' + value._id;
    } else {
      return '/a/' + value._id;
    }
  }

  showToast(type: 'success' | 'error' | 'info', message: string){
    toast[type](message, {
      position: 'top-right',
    });
  };

  getCommentIndexAndIsLiked(comment: TComment, user: TUser) {
    const likeIndex = (comment.likes as TUser[])?.findIndex((like) => like._id === user?._id);
    const liked = likeIndex !== -1;
    return { likeIndex, liked };
  }
}

const helperService = new HelperService();
export default helperService;
